import {Component, OnInit} from '@angular/core';
import {CredentialsService} from '@app/auth/credentials.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppService} from '@shared/services/app.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {appVersion} from '@shared/helper/helpers';
import {DialogService} from 'primeng/dynamicdialog';
import {MessageService} from 'primeng/api';

@Component({
    selector: 'app-login',
    templateUrl: './app.login.component.html',
    styleUrls: ['./app.login.component.scss']
})
export class AppLoginComponent implements OnInit {
    version = appVersion;

    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;

    q: string;
    a: string;

    constructor(private credentialsService: CredentialsService,
                private formBuilder: FormBuilder,
                private route: ActivatedRoute,
                private router: Router,
                private http: HttpClient,
                private messageService: MessageService,
                private appService: AppService) {
    }

    ngOnInit(): void {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
        setTimeout(() => this.messageService.clear(), 1000);
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.loginForm.controls;
    }

    login() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.credentialsService.login(this.f.username.value, this.f.password.value).subscribe({
            next: (merchant) => {
                if (merchant.role === 'ADMIN') {
                    this.router.navigate(['/dashboard']);
                } else {
                    this.router.navigate(['/report/sale-report']);
                }
            },
            error: (error) => this.appService.toastError(error)
        });
    }
}
